import { mirrorCloneX } from "../../cloneObject";

export default [
    {
        key: "ogranichitel",
        allArray: "allTableStops",
        activeArray: "activeTableStops",
        position: "bottom",
    },
    {
        key: "planka_dlya_lotkov",
        allArray: "allPlankaDlyaLotkov",
        activeArray: "activePlankaDlyaLotkov",
        position: "top",
    },
    {
        key: "panel_elektromontazhnaya",
        allArray: "allPanelElektromontazhnaya",
        activeArray: "activePanelElektromontazhnaya",
        position: "top",
    },
    {
        key: "perfopanel",
        allArray: "allPerfopanel",
        activeArray: "activePerfopanel",
        position: "top",
        extra: (el) => {
            const bsize = servObj.building.getBoundaryGeometry(el);
            el.userData.bsize = bsize;
        },
    },
    {
        key: "derzhatel_monitora",
        allArray: "allDerzhatelMonitora",
        activeArray: "activeDerzhatelMonitora",
        position: "top",
        extra: (el) => {
            const name = el.name.split("__");
            const newName = `${name[0]}__${name[1]}__left__${name[2]}`;
            el.name = newName;
            el.userData.name = newName;

            const rightDerzhatelMonitora = mirrorCloneX(el, newName);
            rightDerzhatelMonitora.name = rightDerzhatelMonitora.name.replace("left", "right");

            rightDerzhatelMonitora.userData.name = rightDerzhatelMonitora.name;
            servObj.allDerzhatelMonitora.push(rightDerzhatelMonitora);
        },
    },
    {
        key: "osveshchenie_pod_pribornuyu_polku",
        allArray: "allOsveshcheniePodPolkuSMK",
        activeArray: "activeOsveshcheniePodPolkuSMK",
        position: "top",
    },
    {
        key: "polka_pribornaya",
        allArray: "allPolkaPribornayaSMK",
        activeArray: "activePolkaPribornayaSMK",
        position: "top",
    },
];
